import React from 'react';
import { dateToKey } from '../../helpers';
import { ClassData } from '../../types';
import { Calendar } from 'lucide-react';

interface DateListProps {
    dates: Date[];
    selectedDay: Date;
    setSelectedDay: (date: Date) => void;
    classesByDate: Record<string, ClassData[]>;
    isMobileView: boolean;
    onDateClick: () => void;
}

const DateList: React.FC<DateListProps> = ({ dates, selectedDay, setSelectedDay, classesByDate, isMobileView, onDateClick }) => {
    return (
        <div className="bg-slate-900/50 p-2 rounded-xl border border-white/5 h-fit max-h-[75vh] md:max-h-[60vh] overflow-y-auto custom-scrollbar backdrop-blur-sm">
            <h2 className="font-serif text-lg mb-2 p-2 text-slate-400 flex items-center gap-2"><Calendar size={18} /> Schedule</h2>
            <div className="flex flex-col gap-1">
                {dates.map((date) => {
                    const key = dateToKey(date);
                    const isSelected = key === dateToKey(selectedDay);
                    const dayHasClasses = !!classesByDate[key] && classesByDate[key].length > 0;
                    
                    return (
                    <button key={dateToKey(date)} onClick={() => {
                        setSelectedDay(date);
                        if (isMobileView) {
                            onDateClick();
                        }
                    }}
                        className={`
                        relative text-left px-4 py-3 rounded-lg text-sm flex justify-between items-center transition-all duration-200
                        ${isSelected 
                            ? 'bg-fuchsia-700 text-white shadow-lg shadow-fuchsia-900/50 scale-[1.02]' 
                            : 'hover:bg-white/5 text-slate-400 hover:text-slate-200'
                        }
                        ${!isSelected && dayHasClasses ? 'bg-slate-800/50 border-l-4 border-rose-500' : ''}
                        `}>
                        <span className="flex flex-col">
                            <span className={`text-xs uppercase tracking-wider ${isSelected ? 'text-fuchsia-200' : 'text-slate-500'}`}>
                            {date.toLocaleDateString('en-US', { weekday: 'short' })}
                            </span>
                            <span className="text-lg font-bold">{date.getDate()}</span>
                        </span>
                        
                        {dayHasClasses && !isSelected && (
                            <span className="text-xs font-bold text-rose-500 bg-rose-900/20 px-2 py-0.5 rounded">Class</span>
                        )}
                    </button>
                    );
                })}
            </div>
        </div>
    );
};

export default DateList;
